import { render, staticRenderFns } from "./ImportantMessageArea.vue?vue&type=template&id=577454db&scoped=true&"
import script from "./ImportantMessageArea.vue?vue&type=script&lang=ts&"
export * from "./ImportantMessageArea.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantMessageArea.vue?vue&type=style&index=0&id=577454db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577454db",
  null
  
)

export default component.exports